<!--
 * @Author: Cathy
 * @Date: 2020-02-27 10:43:41
 * @LastEditors: Cathy
 * @LastEditTime: 2020-02-27 10:48:35
 * @Description: 请打开浏览器遮罩层组件
 -->
<template>
 <div
      class="isWeixin"
      v-if="isWeixin"
      @click="$emit('onCancelMark')"
    >
      <p class="toastText">
        请在手机浏览器中打开
        <img src="../assets/images/oblique_arrow.png" />
      </p>
    </div>
</template>

<script>
export default {
  name: 'isWeixinMark',
  props: {
    isWeixin: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
.isWeixin {
  width: 100%;
  height: 100vh;
  background-color: rgba(13, 13, 13, 0.6);
  position: fixed;
  top: 0;
  left: 0;
}
.toastText {
  color: rgba(255, 255, 255, 0.7);
  margin: 0.1rem 0.4rem 0 0;
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
}
.toastText img {
  width: 1.25rem;
  height: 1.25rem;
  margin-left: 0.1rem;
  opacity: 0.7;
}
</style>
